"use strict";
/** state: Final **/
/** family: NavBar **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var trackMetric_1 = require("../../metrics/trackMetric");
var Dropdown_1 = require("../Dropdown");
var DropdownItem_1 = require("../DropdownItem");
var NavItemArrow_1 = require("../NavItemArrow");
var NavItemContent_1 = require("../NavItemContent");
var SafeAnchor_1 = require("../SafeAnchor");
var utils_1 = require("../utils");
var NavDropdown = /** @class */ (function (_super) {
    __extends(NavDropdown, _super);
    function NavDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleDropdown = function (e) {
            e.preventDefault();
            trackMetric_1.trackMetric(_this.props.metricOptions, _this.props.onClick);
            _this.setState(function (prevState) { return ({
                isOpen: !prevState.isOpen,
            }); });
            return false;
        };
        /**
         * Inject `onClick` handler to DropdownItem children to close on click.
         */
        _this.injectPropsOnChildren = function () {
            return React.Children.map(_this.props.children, function (child) {
                if (utils_1.isType(child, DropdownItem_1.DropdownItem)) {
                    return React.cloneElement(child, {
                        onClick: function (e) {
                            _this.setState(function (prevState) { return ({
                                isOpen: !prevState.isOpen,
                            }); });
                            child.props.onClick && child.props.onClick(e);
                        },
                    });
                }
                return child;
            });
        };
        _this.closeDropdown = function (e) {
            _this.setState({
                isOpen: false,
            });
            /**
             * A bit of hackery to maintain the old functionality of NavDropdown.
             * Essentially this clicks through the Dropdown.
             * We need to account for how far the page has scrolled, as pageX/pageY
             * operate based on the whole document, while elementFromPoint only
             * considers the visible section of the document.
             */
            if (e) {
                var clickSpot_1 = {
                    x: e.pageX - pageXOffset,
                    y: e.pageY - pageYOffset,
                };
                setTimeout(function () {
                    var clickElement = document.elementFromPoint(clickSpot_1.x, clickSpot_1.y);
                    if (!document
                        .getElementById(_this.props.id)
                        .contains(clickElement)) {
                        clickElement.click();
                    }
                }, 1);
            }
        };
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    NavDropdown.prototype.render = function () {
        var _a;
        var _b = this.props, activeArrowShown = _b.activeArrowShown, activeArrowStyle = _b.activeArrowStyle, badge = _b.badge, caretHidden = _b.caretHidden, children = _b.children, className = _b.className, label = _b.label, labelHidden = _b.labelHidden, layout = _b.layout, icon = _b.icon, iconName = _b.iconName, isMobile = _b.isMobile, onClick = _b.onClick, metricOptions = _b.metricOptions, mobileIcon = _b.mobileIcon, mobileIconName = _b.mobileIconName, restProps = __rest(_b, ["activeArrowShown", "activeArrowStyle", "badge", "caretHidden", "children", "className", "label", "labelHidden", "layout", "icon", "iconName", "isMobile", "onClick", "metricOptions", "mobileIcon", "mobileIconName"]);
        var navItemClasses = classNames('nav-item', 'dropdown', 'i-nav-item', (_a = {
                active: this.state.isOpen,
                'i-nav-arrow': activeArrowShown
            },
            _a["i-nav-arrow--" + activeArrowStyle + "-bottom"] = activeArrowShown,
            _a), className);
        var navLinkClasses = classNames('nav-link', {
            'dropdown-toggle': !caretHidden,
        });
        return (React.createElement("li", __assign({ className: navItemClasses }, restProps),
            React.createElement(Dropdown_1.Dropdown, { role: Dropdown_1.Dropdown.Role.Menu, isOpen: this.state.isOpen, onOutsideClick: this.closeDropdown, rightAlign: true, toggle: React.createElement(SafeAnchor_1.SafeAnchor, { "aria-expanded": this.state.isOpen, "aria-label": label, "aria-haspopup": true, className: navLinkClasses, onClick: this.toggleDropdown },
                    React.createElement(NavItemContent_1.NavItemContent, { badge: badge, icon: icon, iconName: iconName, isMobile: isMobile, label: label, labelHidden: labelHidden, layout: layout, mobileIcon: mobileIcon, mobileIconName: mobileIconName })) }, this.injectPropsOnChildren())));
    };
    NavDropdown.ArrowStyle = NavItemArrow_1.NavItemArrowStyle;
    NavDropdown.Item = DropdownItem_1.DropdownItem;
    NavDropdown.Layout = NavItemContent_1.NavLayout;
    NavDropdown.defaultProps = {
        activeArrowShown: true,
        activeArrowStyle: NavDropdown.ArrowStyle.Inset,
    };
    return NavDropdown;
}(React.Component));
exports.NavDropdown = NavDropdown;
//# sourceMappingURL=NavDropdown.js.map